<template>
  <div id="app">
    <Navbar />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Navbar from "./components/navbar";
import Footer from "./components/footer";
export default {
  name: "App",

  components: {
    Navbar,
    Footer
  },

  data: () => ({})
};
</script>


<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;0,900;1,600&display=swap");
body {
  font-family: "Nunito Sans", sans-serif !important;
}
.mt-50 {
  padding-top: 100px;
}
.mb-50 {
  padding-bottom: 100px;
}
.mt-30 {
  padding-top: 50px;
}
.mb-30 {
  padding-bottom: 50px;
}
.pb-50 {
  padding-bottom: 50px;
}
@media (max-width: 767px) {
  .mt-50 {
    padding-top: 30px;
  }
  .mb-50 {
    padding-bottom: 30px;
  }
  .mt-30 {
    padding-top: 10px;
  }
  .mb-30 {
    padding-bottom: 10px;
  }
}
// loader
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #aaa;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #aaa transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
}
</style>